import {useEffect} from 'react';
import {CLICK_OUTSIDE_EXCLUDED_SELECTORS} from '../utils/clickOutsideExcludedSelectors';

const EXCLUDED_SELECTORS = [
    '[data-cy*="userMessage"]',
    '.countries-list',
    '.phone-container',
    ...CLICK_OUTSIDE_EXCLUDED_SELECTORS,
];

const UseMouseUpOutside = (ref, handler) => {
    useEffect(
        () => {
            const listener = (event) => {
                if(!ref.current || ref.current.contains(event.target)) {
                    return;
                }

                for(const selector of EXCLUDED_SELECTORS) {
                    if(event.target.closest?.(selector)) {
                        return;
                    }
                }

                handler(event);
            };
            document.addEventListener('mouseup', listener);
            return () => {
                document.removeEventListener('mouseup', listener);
            };
        },
        [ref, handler]
    );
};

export default UseMouseUpOutside;
